import { Banner } from '../../../banner/Banner';
import { ENTITY_BANNER_COLOR_MAP, ENTITY_BANNER_TYPE_ICON_MAP, EntityBannerType } from './constant';
import { BANNER_COLORS } from '../../../banner/constants';
import { LinkButton } from '../../../link/LinkButton';
import { ExpandableContent } from '../ExpandableContent/ExpandableContent';

function EntityBanner({
  dataId,
  type,
  title,
  content,
  docLink,
  className
}: {
  dataId: string;
  type: EntityBannerType;
  title?: string;
  content?: string;
  docLink?: string;
  className?: string;
}) {
  const icon = ENTITY_BANNER_TYPE_ICON_MAP[type as EntityBannerType];
  const color = ENTITY_BANNER_COLOR_MAP[type as EntityBannerType];

  return (
    <Banner
      open
      dataId={dataId}
      icon={icon}
      color={color as (typeof BANNER_COLORS)[number]}
      className={className}
    >
      {title ? <span className='text-medium'>{title}</span> : null}

      {title && content ? <>:&nbsp;</> : null}

      {content ? (
        <ExpandableContent>
          <span>{content}</span>

          {docLink && (
            <LinkButton
              dataId='show-more-button'
              className='ml-2'
              onClick={() => window.open(docLink, '_blank')}
            >
              &nbsp;Learn more
            </LinkButton>
          )}
        </ExpandableContent>
      ) : null}
    </Banner>
  );
}

export default EntityBanner;
